module.exports = __webpack_public_path__ + "static/media/1.07ce524b.jpg";